import { Route, Routes } from "react-router-dom";
import App from "./App";
import MobileApp from "./mobile/App";
import { ScrollToTopProvider } from "../../contexts/ScrollToTopContext";
import { useMediaQueries } from "../../utils/mediaQueries";

const AppPage = () => {
  const { isMobile } = useMediaQueries();
  
  return (
    <ScrollToTopProvider>
      {isMobile ? <MobileApp /> : <App />}
    </ScrollToTopProvider>
  );
};

export default AppPage;